<template>
  <v-flex class="py-3 px-2" xs12 sm11 lg10>
    <v-card class="elevation-2">
      <transition name="fade" mode="out-in" appear>
        <div v-if="loading" class="py-5 text-xs-center"><div class="my-5 py-5"><div class="my-5 py-5">
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </div></div></div>
        <router-view v-else></router-view>
      </transition>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  data: () => ({
    loading: false
  }),
  mounted () {
    this.load()
  },
  methods: {
    load () {
      let appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.$store.getters.user) {
        let contentLoaded = this.$store.getters.contentLoaded && this.$store.getters.sectionsLoaded && this.$store.getters.tasksLoaded
        let progressModuleLoaded = this.$store.getters.progressLoaded && this.$store.getters.taskProgressLoaded
        if (contentLoaded && progressModuleLoaded) this.loading = false
        else {
          this.$store.dispatch('loadContent').then(() => {
            this.$store.dispatch('loadSections').then(() => {
              this.$store.dispatch('loadTasks').then(() => {
                this.$store.dispatch('loadProgress').then(() => {
                  this.$store.dispatch('loadTaskProgress', this.$store.getters.user.uid).then(() => {
                    this.loading = false
                  })
                })
              })
            })
          })
        }
      } else {
        appMsg.msg = 'Please sign in'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/sign-in')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myCourses/MyCourses.vue